type SaleSubscriptionFields = {
  halley_subscription_public_id?: string | null;
  is_subscription_renewal?: boolean;
  subscription_cycle_number?: number | null;
};

/**
 * Rótulo da listagem: ciclo 1 = Assinatura; ciclo ≥2 = Assinatura · ciclo N;
 * renovação Halley sem número = Assinatura · renovação.
 */
export function resolveSaleSubscriptionLabel(
  sale: SaleSubscriptionFields,
  t: (key: string, options?: Record<string, unknown>) => string,
): string | null {
  const cycle = sale.subscription_cycle_number ?? null;

  if (cycle !== null && cycle >= 2) {
    return t('sales:subscription_cycle', { n: cycle });
  }

  if (sale.is_subscription_renewal) {
    return t('sales:subscription_renewal');
  }

  if (sale.halley_subscription_public_id) {
    return t('sales:subscription');
  }

  return null;
}
